import React, { useContext } from "react";
import "./_wizard.scss";

import { GlobalContext } from "./../../../utils/global-context";
import Loader from "./../../01-atoms/loader/loader";
import Sidebar from "../sidebar/sidebar";

const Wizzard = () => {
  const {
    currentStep,
    currentImage,
    currentOptions,
    defaultImage,
    imageOpacity,
    wizardTheme,
    wizardTitle,
    wizardDescription,
  } = useContext(GlobalContext) || {};

  let wizardImageText = null;
  if (wizardTheme === 'visualization_2' && wizardTitle) {
    wizardImageText = (
      <div>
        <h2>{wizardTitle}</h2>
        <p>{wizardDescription}</p>
      </div>
    );
  }

  return currentStep
    ? (
      <div className={`wizard ${wizardTheme ? wizardTheme : 'visualization_1'}`}>

        <div className="wizard__image">
          {currentImage
            ? <img src={currentImage} alt="Step Current" style={{ opacity: imageOpacity }} />
            : defaultImage && <img src={defaultImage} alt="Default" style={{ opacity: imageOpacity }} />
          }
          <>{wizardImageText}</>
        </div>

        <Sidebar
          heading={{
            title: currentStep.fieldTitle,
            description: currentStep.fieldDescription?.trim() || null,
          }}
          steps={currentOptions}
        />
      </div>
    )
    : <Loader />;
};

export default Wizzard;
